import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { Store } from '@ngrx/store';
import { lastValueFrom, Observable } from 'rxjs';
import { FormUtilityService } from 'src/app/modules/core/services/form-utility.service';
import { BeyCountrySelectorOptionInterface } from 'src/assets/interfaces/bey-country-selector.interface';
import { phoneNumberValidator } from 'src/assets/utility/form.validators';
import { sendVerificationCodeStart } from '../../../../../ngrx/auth/auth.actions';
import { selectSendVerificationCodeIsLoading } from '../../../../../ngrx/auth/auth.selectors';
import { getOptionsForCountrySelector } from '../../../../../../assets/utility';
import { HttpClient } from '@angular/common/http';
import { AsyncPipe } from '@angular/common';
import { BeyButtonComponent } from '../../../../shared/components/bey-button/bey-button.component';
import { BeyCountryPhoneNumberInputComponent } from '../../../../shared/components/bey-country-phone-number-input/bey-country-phone-number-input.component';
import { GetElementIdDirective } from '../../../../shared/directives/get-element-id.directive';

@Component({
  selector: 'app-phone-number',
  templateUrl: './phone-number.component.html',
  styleUrls: ['./phone-number.component.scss'],
  standalone: true,
  imports: [
    ReactiveFormsModule,
    BeyCountryPhoneNumberInputComponent,
    BeyButtonComponent,
    RouterLink,
    AsyncPipe,
    GetElementIdDirective,
  ],
})
export class PhoneNumberComponent implements OnInit {
  sendVerificationCodeIsLoading$: Observable<boolean>;
  form: UntypedFormGroup;
  countries: Array<BeyCountrySelectorOptionInterface> = [];

  constructor(
    public router: Router,
    public route: ActivatedRoute,
    private store$: Store,
    public formUtility: FormUtilityService,
    private http: HttpClient
  ) {}

  ngOnInit(): void {
    this.sendVerificationCodeIsLoading$ = this.store$.select(selectSendVerificationCodeIsLoading);

    this.form = new UntypedFormGroup({
      phone: new UntypedFormControl('', [Validators.required, phoneNumberValidator(true)]),
    });

    getOptionsForCountrySelector()
      .then((countries) => {
        this.countries = countries;
        return lastValueFrom(this.http.get('https://api.ip.sb/geoip'));
      })
      .then((result) => {
        if (result?.['country']) {
          const userCountry = this.countries.find((c) => c.label === result?.['country']);

          if (userCountry) {
            this.form.get('phone').setValue(userCountry?.['value']);
          }
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }

  handleSubmit(): void {
    const { phone } = this.form.value;

    this.store$.dispatch(
      sendVerificationCodeStart({
        payload: { phone, resetPin: true },
      })
    );
  }
}
